/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Outlook_Ingest_Approval_DeniedInputs */

const es_components_outlook_ingest_approval_denied = /** @type {(inputs: Components_Outlook_Ingest_Approval_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingesta de adjuntos denegada`)
};

const en_components_outlook_ingest_approval_denied = /** @type {(inputs: Components_Outlook_Ingest_Approval_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Attachment ingestion denied`)
};

/**
* | output |
* | --- |
* | "Attachment ingestion denied" |
*
* @param {Components_Outlook_Ingest_Approval_DeniedInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const components_outlook_ingest_approval_denied = /** @type {((inputs?: Components_Outlook_Ingest_Approval_DeniedInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Outlook_Ingest_Approval_DeniedInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_components_outlook_ingest_approval_denied(inputs)
	return en_components_outlook_ingest_approval_denied(inputs)
});
export { components_outlook_ingest_approval_denied as "components.outlook_ingest_approval.denied" }